import { actionTypesMaker } from 'redux/lib/utils';

const actionTypes = [
    'GET_SAMPLE_LIST_SUCCESS',
    'GET_FEATURE_TREE_SUCCESS',
    'GET_PREDICT_THRESHOLD_SUCCESS',
];

export default actionTypesMaker('PRIVATE_MODEL', actionTypes);
